import { on, reducer } from 'ts-action';

import {
    setCoordinateData,
    setProductList,
    setProductListWithReset,
    setProducts,
    updateCoordinateData,
    updateDataFilter,
    setDataFilter,
    setNeighborsProducts,
    setProductDetails,
    setFactSheetPDF,
    setFactSheetXLSX,
    setBookingYear,
    setSmartPhrases,
    setSmartPhrasesList,
    setSmartPhrase,
    createNewAbortController,
    setSujetcheckImageData,
    setSujetcheckImages,
} from './actions';

import { CoordinateMode } from '../../models/coordinate.model';
import { ProductModel } from '../../models/products.model';

import { LocationState } from './';

const initialState: LocationState = {
    controller: new AbortController(),
    filter: {
        attributes: [],
        restrictions: [],
        duration: [],
        format: [],
        pricerange: [],
        commspace: [],
        category: [],
        type: [],
        bookingyear: [],
        basketreference: undefined,
        basket: undefined,
    },
    dataList: {
        data: {
            count: 0,
            eod: false,
            groupcount: 0,
            products: [],
        },
    },
    dataProducts: {
        data: [],
    },
    dataProduct: {
        data: null,
    },
    dataNeighborsProducts: [],
    coordinate: {
        mode: CoordinateMode.Radius,
        radius: Number(1000),
    },
    factsheetLinkPDF: '',
    factsheetLinkPPT: '',
    factsheetLinkXLSX: '',
    bookingYear: new Date().getFullYear(),
    smartPhrase: undefined,
    smartPhrases: [],
    smartPhrasesList: [],
    sujetcheckAssetData: undefined,
    sujetcheckImages: undefined,
};

export default reducer(
    initialState,
    on(setNeighborsProducts, (state, { payload }) => ({ ...state, dataNeighborsProducts: payload })),
    on(setProducts, (state, { payload }) => ({ ...state, dataProducts: payload })),
    on(setProductListWithReset, (state, { payload }) => ({ ...state, dataList: payload })),
    on(setProductList, (state, { payload }) => {
        const products = [...state.dataList.data.products, ...payload.data.products] as ProductModel[];

        return {
            ...state,
            dataList: {
                ...payload,
                data: {
                    ...payload.data,
                    products,
                    count: payload.data.count || products.length,
                    groupcount: payload.data.groupcount || products.length,
                },
            },
        };
    }),
    on(setDataFilter, (state, { payload }) => ({ ...state, filter: payload })),
    on(setProductDetails, (state, { payload }) => ({ ...state, dataProduct: payload })),
    on(updateDataFilter, (state, { payload }) => ({ ...state, filter: payload })),
    on(updateCoordinateData, (state, { payload }) => ({ ...state, coordinate: { ...state.coordinate, ...payload } })),
    on(setCoordinateData, (state, { payload }) => ({ ...state, coordinate: payload })),
    on(setFactSheetPDF, (state, { payload }) => ({ ...state, factsheetLinkPDF: payload })),
    on(setFactSheetXLSX, (state, { payload }) => ({ ...state, factsheetLinkXLSX: payload })),
    on(setBookingYear, (state, { payload }) => ({ ...state, bookingYear: payload })),
    on(setSmartPhrase, (state, { payload }) => ({ ...state, smartPhrase: payload })),
    on(setSmartPhrases, (state, { payload }) => ({ ...state, smartPhrases: payload })),
    on(setSmartPhrasesList, (state, { payload }) => ({ ...state, smartPhrasesList: payload })),
    on(setSujetcheckImageData, (state, { payload }) => ({ ...state, sujetcheckAssetData: payload })),
    on(setSujetcheckImages, (state, { payload }) => ({ ...state, sujetcheckImages: payload })),
    on(createNewAbortController, state => ({ ...state, controller: new AbortController() }))
);
